import React from 'react';

const MessageDetail = ({color="success", mensaje}) => {
    return (
        <div className={`p-message p-component p-message-${color} p-message-enter-done`}>
            <div className="p-message-wrapper">
                {mensaje}
            </div>
        </div>
    );
}

export default MessageDetail;
//success, info, warn, error